import builder from '../builder';
import CameraSettingsRotate1 from '../../streamline-icons/bold/camera-settings-rotate-1.svg';

export default builder('IconCameraSettingsRotate1Bold', CameraSettingsRotate1);
